import { PropsWithChildren } from 'react';

interface RenderIfProps {
  condition: boolean;
}

const RenderIf = ({ condition, children }: PropsWithChildren<RenderIfProps>) => {
  if (!condition) {
    return null;
  }

  return <>{children}</>;
};

export { RenderIf };
